import { jsxs as i, jsx as c } from "react/jsx-runtime";
import { useState as j, useEffect as x } from "react";
import s from "./styles.module.less.js";
import { QuestionWrapper as D } from "../index.js";
import Q from "./add-icon.svg.js";
import L from "./remove-icon.svg.js";
import { QuestionType as k } from "@law-connect/types";
const O = (q) => {
  var A, C, N;
  const {
    questions: g,
    question: n,
    onChange: d,
    disabled: b = !1,
    language: E,
    getTranslation: u,
    errors: p
  } = q, f = (t, e) => {
    for (const r of e) {
      if (r.id === t)
        return r;
      if (r.type === k.MultiPart) {
        const a = f(t, r.questions);
        if (a)
          return a;
      }
      if (r.type === k.Items && r.answer)
        for (const a of r.answer) {
          const o = f(t, a);
          if (o)
            return o;
        }
    }
    return null;
  }, [w, v] = j(0), I = (t) => (e) => {
    e.preventDefault(), v(t);
  }, h = (t) => {
    t.stopPropagation(), t.preventDefault();
    const e = {
      ...n,
      answer: [
        ...n.answer || [],
        n.questions
      ]
    };
    d(e), v(
      e.answer && e.answer.length > 0 ? e.answer.length - 1 : 0
    );
  }, T = (t) => (e) => {
    var a;
    e.stopPropagation(), e.preventDefault();
    const r = {
      ...n,
      answer: (a = n.answer) == null ? void 0 : a.filter(
        (o, l) => l !== t
      )
    };
    d(r), v(t - 1 > 0 ? t - 1 : 0);
  }, P = (t) => (e) => {
    const r = { ...n, answer: n.answer ? [...n.answer] : void 0 };
    r.answer && r.answer[t] && (r.answer[t] = r.answer[t].map((a) => a.id === e.id ? e : a)), d(r);
  };
  x(() => {
    n.answer || h(new MouseEvent("click"));
  }, []);
  const $ = (t) => {
    if (!p) return !1;
    const e = `${n.id}-${t}-`;
    return Object.keys(p).some((r) => r.startsWith(e));
  }, y = (t, e) => {
    var l;
    const r = (l = t.find((m) => m.id === n.label)) == null ? void 0 : l.answer, a = $(e), o = n.label && r && typeof r != "object" ? r || u("prematter.new") : n.label ? `${n.label} #${e + 1}` : `#${e + 1}`;
    return a ? `${o} *` : o;
  };
  return /* @__PURE__ */ i("div", { className: s.tabList, children: [
    /* @__PURE__ */ i("div", { className: s.tabItems, children: [
      (A = n.answer) == null ? void 0 : A.map((t, e) => {
        const r = $(e);
        return /* @__PURE__ */ c(
          "button",
          {
            onClick: I(e),
            className: `${s.tabItem} ${e === w ? s.active : ""} ${r ? s.error : ""}`,
            children: y(t, e)
          },
          e
        );
      }),
      /* @__PURE__ */ i("button", { onClick: h, className: s.tabAdd, disabled: b, children: [
        /* @__PURE__ */ c(Q, {}),
        " ",
        u("prematter.add")
      ] })
    ] }),
    (C = n.answer) == null ? void 0 : C.map((t, e) => /* @__PURE__ */ i(
      "div",
      {
        className: `${s.tab} ${e === w ? s.active : ""}`,
        children: [
          t.map((r, a) => {
            if (r.onlyAvailableIf) {
              const o = r.onlyAvailableIf;
              let l = f(
                o.questionId,
                t
              );
              if (l || (l = f(
                o.questionId,
                g
              )), l) {
                let m = !1;
                if (Array.isArray(o.answer) ? m = o.answer.includes(
                  l.answer
                ) : m = l.answer === (o == null ? void 0 : o.answer), !m)
                  return null;
              }
            }
            return /* @__PURE__ */ c(
              D,
              {
                questions: g,
                question: r,
                onChange: P(e),
                disabled: b,
                language: E,
                getTranslation: u,
                namePrefix: `tab-${e}`,
                errors: p,
                errorKeyPrefix: `${n.id}-${e}-`
              },
              a
            );
          }),
          /* @__PURE__ */ i("button", { onClick: T(e), className: s.tabRemove, children: [
            /* @__PURE__ */ c(L, {}),
            " ",
            u("prematter.remove")
          ] })
        ]
      },
      e
    )),
    /* @__PURE__ */ i("div", { className: s.tabItems, children: [
      (N = n.answer) == null ? void 0 : N.map((t, e) => {
        const r = $(e);
        return /* @__PURE__ */ c(
          "button",
          {
            onClick: I(e),
            className: `${s.tabItem} ${s.reverse} ${e === w ? s.active : ""} ${r ? s.error : ""}`,
            children: y(t, e)
          },
          e
        );
      }),
      /* @__PURE__ */ i("button", { onClick: h, className: s.tabAdd, disabled: b, children: [
        /* @__PURE__ */ c(Q, {}),
        " ",
        u("prematter.add")
      ] })
    ] })
  ] });
};
export {
  O as QuestionTabList
};
